import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";

export default function AttendanceWidget({
  status,
  notes,
  sessionId,
  onPresent,
  onAbsent,
}) {
  const isScheduled = status === "SCHEDULED";
  const isPresent = status === "PRESENT";
  const isAbsent = status === "ABSENT";

  const handleClick = (type) => {
    if (!isScheduled) return;

    type === "PRESENT"
      ? onPresent(sessionId)
      : onAbsent(sessionId);
  };

  const buttonStyle = (active, color) => ({
    px: 1.5,
    py: 0.65,
    minWidth: 85,
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: 600,
    cursor: isScheduled ? "pointer" : "default",
    backgroundColor: active ? color : "#f7f7f7",
    color: active ? "#fff" : "#8a8a8a",
    border: active
      ? `1px solid ${color}`
      : "1px solid #e0e0e0",
    transition: "all 0.2s ease",
    "&:hover": isScheduled
      ? {
          backgroundColor: color,
          color: "#fff",
          borderColor: color,
        }
      : {},
  });

  const present = (
    <Box
      onClick={() => handleClick("PRESENT")}
      sx={buttonStyle(isPresent, "#2e9b62")}
    >
      ✓ Present
    </Box>
  );

  const absent = (
    <Box
      onClick={() => handleClick("ABSENT")}
      sx={buttonStyle(isAbsent, "#d9534f")}
    >
      ✕ Absent
    </Box>
  );

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        width: "100%",
        height: "100%",
      }}
    >
      {isPresent ? (
        <Tooltip title={notes || "No notes"}>
          {present}
        </Tooltip>
      ) : (
        present
      )}

      {isAbsent ? (
        <Tooltip title={notes || "No notes"}>
          {absent}
        </Tooltip>
      ) : (
        absent
      )}
    </Box>
  );
}